<div class="relative flex">
  <!-- Prefijo: bandera + código -->
  <button
    type="button"
    (click)="toggle()"
    [disabled]="disabled"
    class="flex items-center gap-1.5 shrink-0 h-11 rounded-l-lg border border-r-0 border-gray-300 bg-gray-50 px-3 text-sm text-gray-800 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 disabled:opacity-60 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90">
    @if (selected) {
      <span class="fi fi-{{ selected.code.toLowerCase() }} rounded-sm shrink-0"></span>
      <span>{{ selected.dialCode }}</span>
    } @else {
      <span class="text-gray-400">País</span>
    }
    <svg class="w-3.5 h-3.5 text-gray-400 transition-transform" [class.rotate-180]="open"
      fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
    </svg>
  </button>

  <!-- Número -->
  <input
    type="tel"
    [value]="numberPart"
    (input)="onNumberInput($any($event.target).value)"
    (blur)="onBlur()"
    [placeholder]="placeholder"
    [disabled]="disabled"
    class="h-11 w-full rounded-r-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800" />

  <!-- Dropdown de países -->
  @if (open) {
    <div
      class="absolute left-0 top-full mt-1 w-72 max-w-[90vw] bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl shadow-lg overflow-hidden"
      style="z-index: var(--z-dropdown)">
      <div class="p-2 border-b border-gray-100 dark:border-gray-800">
        <input
          type="text"
          [(ngModel)]="query"
          (click)="$event.stopPropagation()"
          placeholder="Buscar país…"
          class="w-full px-3 py-2 text-sm bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg outline-none focus:ring-2 focus:ring-brand-500" />
      </div>
      @if (filtered.length) {
        <cdk-virtual-scroll-viewport [itemSize]="ITEM_SIZE" [style.height.px]="viewportHeight" class="py-1">
          <button
            *cdkVirtualFor="let c of filtered"
            type="button"
            (click)="pick(c)"
            class="w-full flex items-center gap-2 px-3 h-9 text-sm text-left hover:bg-gray-100 dark:hover:bg-gray-800"
            [class.bg-brand-50]="c.code === countryCode"
            [class.dark:bg-gray-800]="c.code === countryCode">
            <span class="fi fi-{{ c.code.toLowerCase() }} rounded-sm shrink-0"></span>
            <span class="flex-1 truncate text-gray-900 dark:text-white">{{ c.name }}</span>
            <span class="text-xs text-gray-400 shrink-0">{{ c.dialCode }}</span>
          </button>
        </cdk-virtual-scroll-viewport>
      } @else {
        <div class="px-3 py-2 text-sm text-gray-400">Sin resultados</div>
      }
    </div>
  }
</div>
